module.exports = __webpack_public_path__ + "static/media/Intro.f05a2078.png";